import { render, staticRenderFns } from "./FolderTagPreview.vue?vue&type=template&id=f33ea62c&scoped=true&"
import script from "./FolderTagPreview.vue?vue&type=script&lang=js&"
export * from "./FolderTagPreview.vue?vue&type=script&lang=js&"
import style0 from "./FolderTagPreview.vue?vue&type=style&index=0&id=f33ea62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33ea62c",
  null
  
)

export default component.exports